import styled from 'styled-components';

export const SearchDrawerWrapper = styled.div`
  height: 100% !important;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 70px;
  gap: 0px 0px;
  align-content: center;
  justify-content: center;
`;

export const ResponsivePickerContent = styled.div`
  height: 100% !important;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr 70px;
  gap: 0px 0px;
  align-content: center;
  justify-content: center;
`;
